
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4AHSJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $500ab5a183a49bf0$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $500ab5a183a49bf0$export$2e2bcd8739ae039 = {
    'fabric.reactions.error.unexpected': "Nie\u010Do sa nepodarilo",
    'fabric.reactions.loading': "Na\u010D\xedtava sa..."
};

});


//# sourceMappingURL=sk.876f9b26.js.map
